import type { ComparisonConfig } from './ComparisonPage';
import { COMPARISON_DE_P3B } from './seo-comparison-p3b.de';


const SITEMINDER_DE: ComparisonConfig = {
  slug: 'hotelstack-vs-siteminder',
  competitorName: 'SiteMinder',
  heroTitle: 'HotelStack.io vs SiteMinder',
  heroSubtitle: 'SiteMinder ist ein australischer Channel Manager, gegruendet 2006, mit Fokus auf OTA-Distribution. HotelStack.io bietet eine vollstaendige 36-Modul-Hotelverwaltungsplattform mit integriertem Channel-Management, PMS, F&B, Ertragstools und mehr — alles zu einem niedrigeren Preis.',
  overviewComparison: [
    { label: 'Plattformtyp', hotelstack: 'All-in-One HMS (36 Module)', competitor: 'Channel Manager + Erweiterungen' },
    { label: 'Preise', hotelstack: 'Ab $49/Monat', competitor: 'Ab $99+/Monat' },
    { label: 'Integriertes PMS', hotelstack: 'Vollstaendiges PMS enthalten', competitor: 'Little Hotelier (Separat)' },
    { label: 'F&B / POS', hotelstack: 'Integriert', competitor: 'Nicht verfuegbar' },
    { label: 'Ertragsmanagement', hotelstack: 'Erweitert (integriert)', competitor: 'Basis-Ertragsregeln' },
    { label: 'Buchungsmaschine', hotelstack: 'BookMyRoom.io (Kostenlos)', competitor: 'TheBookingButton (Zusatzmodul)' },
  ],
  featureTable: [
    {
      category: 'Kern-PMS',
      features: [
        { name: 'Visuelle Zimmertafel', hotelstack: true, competitor: false },
        { name: 'Reservierungsverwaltung', hotelstack: true, competitor: 'Ueber Little Hotelier' },
        { name: 'Nachtabschluss-Assistent', hotelstack: true, competitor: false },
        { name: 'Gastefolio-Verwaltung', hotelstack: true, competitor: false },
        { name: 'Gruppenbuchungen', hotelstack: true, competitor: false },
        { name: 'Online Check-In Portal', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Distribution & Channel-Management',
      features: [
        { name: 'Channel Manager (100+ OTAs)', hotelstack: true, competitor: true },
        { name: 'GDS-Anbindung', hotelstack: true, competitor: true },
        { name: 'Metasuche-Integration', hotelstack: true, competitor: true },
        { name: 'Ratenparitaetsueberwachung', hotelstack: true, competitor: true },
        { name: 'Direkte Buchungsmaschine', hotelstack: true, competitor: 'Zusatzmodul' },
      ],
    },
    {
      category: 'Ertragsmanagement',
      features: [
        { name: 'Dynamische Preisregeln', hotelstack: true, competitor: 'Basis' },
        { name: 'Was-Waere-Wenn-Ertragssimulator', hotelstack: true, competitor: false },
        { name: 'Wettbewerbspreise-Monitor', hotelstack: true, competitor: false },
        { name: 'Nachfrageprognose', hotelstack: true, competitor: false },
        { name: 'RevPAR-Analysen', hotelstack: true, competitor: 'Basis' },
      ],
    },
    {
      category: 'Gaeste & Betrieb',
      features: [
        { name: '360-Grad-Gaesteprofile', hotelstack: true, competitor: false },
        { name: 'Housekeeping-Verwaltung', hotelstack: true, competitor: false },
        { name: 'POS-Terminal', hotelstack: true, competitor: false },
        { name: 'Zimmerservice-Modul', hotelstack: true, competitor: false },
        { name: 'Personalplanung', hotelstack: true, competitor: false },
        { name: 'Wartungsauftraege', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Multi-Property & Compliance',
      features: [
        { name: 'Ketten-Dashboard', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Objektuebergreifende Analysen', hotelstack: true, competitor: false },
        { name: 'Mehrwaehrungsabrechnung', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Regionale Steuerkonformitaet', hotelstack: true, competitor: false },
        { name: 'Treueprogramm-Verwaltung', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resilienz & Offline',
      features: [
        { name: 'Offlinefaehige PWA', hotelstack: true, competitor: false },
        { name: 'Offline-Warteschlange fuer Aenderungen', hotelstack: true, competitor: false },
        { name: 'Hintergrundsynchronisierung bei Wiederverbindung', hotelstack: true, competitor: false },
        { name: 'Konfliktbewusster Abgleich', hotelstack: true, competitor: false },
        { name: 'Installierbare Rezeption', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Firmenkunden & Gruppenverkauf',
      features: [
        { name: 'Firmenratenverwaltung', hotelstack: true, competitor: false },
        { name: 'Gruppenbuchung mit Zimmerlisten', hotelstack: true, competitor: false },
        { name: 'Offene-Posten- & Produktionsberichte', hotelstack: true, competitor: false },
        { name: 'Restaurantreservierungen', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal & HR',
      features: [
        { name: 'Mitarbeiterverzeichnis & Dienstplanung', hotelstack: true, competitor: false },
        { name: 'Lohnabrechnung', hotelstack: true, competitor: false },
        { name: 'Urlaub & Anwesenheit', hotelstack: true, competitor: false },
        { name: 'Leistungsanalysen', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$99+',
    hotelstackNote: 'Alle 36 Module enthalten — PMS, Channel Manager, Buchungsmaschine, F&B, Ertragsmanagement. Regionale Preise in EUR, GBP, AED, INR, THB. Kostenloses Onboarding und Migration.',
    competitorNote: 'Channel Manager ab $99+/Monat. PMS (Little Hotelier) und Buchungsmaschine (TheBookingButton) sind separate Produkte mit separaten Gebuehren. Keine F&B- oder Betriebsmodule.',
  },
  advantages: [
    'Vollstaendige All-in-One-Plattform mit 36 Modulen vs. SiteMinder-Ansatz nur als Channel Manager',
    'Vollstaendiges PMS integriert — kein separater Kauf von Little Hotelier fuer die Objektverwaltung noetig',
    'F&B, POS, Zimmerservice und Kuechenmanagement ohne Zusatzkosten enthalten',
    'Fortschrittliches Ertragsmanagement mit dynamischer Preisgestaltung, Prognose und Was-Waere-Wenn-Simulatoren',
    'Gaeste-CRM mit 360-Grad-Profilen, Treueprogrammen und automatisierter Kommunikation',
    'Betriebstools: Housekeeping, Wartung, Personalplanung — alles integriert',
    'Niedrigerer Einstiegspreis ($49 vs. $99+) mit deutlich mehr enthaltener Funktionalitaet',
    'Kostenloses Onboarding und Datenmigration mit 24/7 dediziertem Support',
  ],
  verdict: {
    title: 'Unser Fazit',
    summary: 'SiteMinder glaenzt als eigenstaendiger Channel Manager mit starker OTA-Anbindung, aufgebaut ueber fast zwei Jahrzehnte. Es ist jedoch keine vollstaendige Hotelverwaltungsplattform. HotelStack.io umfasst alles, was SiteMinder bei der Distribution bietet, plus ein vollstaendiges PMS, F&B/POS, Ertragsmanagement, Gaeste-CRM und 25+ weitere Module — alles in einem Abonnement zu einem niedrigeren Preis.',
    bestFor: [
      'Hotels, die eine einzige Plattform statt SiteMinder + PMS + POS zusammenzusetzen wuenschen',
      'Objekte, die vollstaendiges PMS, F&B und Betriebstools ueber Channel-Management hinaus benoetigen',
      'Hotels, die fortschrittliches Ertragsmanagement und Nachfrageprognose wuenschen',
      'Kleine Objekte, denen SiteMinder nur fuer Distribution zu teuer ist',
      'Hotelketten, die zentralisierte Verwaltung ueber alle Betriebsbereiche benoetigen',
    ],
  },
  faqItems: [
    { question: 'Kann ich von SiteMinder zu HotelStack.io migrieren?', answer: 'Ja. Unser Migrationsteam uebertraegt Ihre OTA-Verbindungen, Tarifplaene und Buchungsdaten. HotelStack.io verbindet sich mit denselben 100+ OTAs, die SiteMinder unterstuetzt. Die Migration ist kostenlos und wird in der Regel innerhalb von 48 Stunden ohne Ausfallzeiten abgeschlossen.' },
    { question: 'Erreicht HotelStack.io die Channel-Management-Funktionen von SiteMinder?', answer: 'Ja. HotelStack.io umfasst einen vollstaendigen Channel Manager mit Anbindung an 100+ OTAs, GDS ueber Amadeus und Sabre sowie Metasuche-Plattformen. Ratenparitaetsueberwachung und Echtzeit-Bestandssynchronisation sind Standardfunktionen in jedem Plan.' },
    { question: 'Warum HotelStack.io statt SiteMinder + Little Hotelier waehlen?', answer: 'Der separate Kauf von SiteMinder (Channel Manager) plus Little Hotelier (PMS) plus TheBookingButton (Buchungsmaschine) kostet deutlich mehr als HotelStack.io, waehrend F&B, Ertragsmanagement, Personalplanung und 20+ weitere Module fehlen, die HotelStack.io bietet.' },
    { question: 'Ist HotelStack.io fuer kleine Objekte geeignet, die derzeit SiteMinder nutzen?', answer: 'Absolut. Unser Starter-Plan fuer $49/Monat umfasst alle 36 Module ohne Funktionsbeschraenkungen. Kleine Objekte erhalten eine vollstaendige Verwaltungsplattform statt nur eines Channel Managers, zu niedrigeren Gesamtkosten als SiteMinder allein.' },
  ],
};

const ROOMRACCOON_DE: ComparisonConfig = {
  slug: 'hotelstack-vs-roomraccoon',
  competitorName: 'RoomRaccoon',
  heroTitle: 'HotelStack.io vs RoomRaccoon',
  heroSubtitle: 'RoomRaccoon ist ein niederlaendisches KI-gesteuertes HMS fuer Boutique- und Kleinhotels. HotelStack.io skaliert von Boutique bis Enterprise mit 36 Modulen, fortschrittlichem Ertragsmanagement, vollstaendigem F&B/POS und Multi-Property-Support — alles zu wettbewerbsfaehigen Preisen.',
  overviewComparison: [
    { label: 'Module gesamt', hotelstack: '36 integrierte Module', competitor: '10+ Module' },
    { label: 'Preise', hotelstack: 'Ab $49/Monat', competitor: 'Ab $79+/Monat' },
    { label: 'Zielsegment', hotelstack: 'KMU bis Enterprise', competitor: 'Boutique / Kleinhotels' },
    { label: 'F&B / POS', hotelstack: 'Integriert', competitor: 'Nicht verfuegbar' },
    { label: 'Multi-Property', hotelstack: 'Vollstaendige Kettenverwaltung', competitor: 'Eingeschraenkt' },
    { label: 'Globale Reichweite', hotelstack: 'Ueber 40 Laender', competitor: 'Hauptsaechlich Europa' },
  ],
  featureTable: [
    {
      category: 'Kern-PMS',
      features: [
        { name: 'Visuelle Zimmertafel', hotelstack: true, competitor: true },
        { name: 'Reservierungsverwaltung', hotelstack: true, competitor: true },
        { name: 'Nachtabschluss-Assistent', hotelstack: true, competitor: true },
        { name: 'Gastefolio-Verwaltung', hotelstack: true, competitor: true },
        { name: 'Gruppenbuchungen', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Online Check-In Portal', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Ertrag & Distribution',
      features: [
        { name: 'Channel Manager (100+ OTAs)', hotelstack: true, competitor: 'Weniger OTAs' },
        { name: 'KI-gestuetztes Yield Management', hotelstack: true, competitor: true },
        { name: 'Dynamische Preisregeln', hotelstack: true, competitor: 'Basis' },
        { name: 'Was-Waere-Wenn-Ertragssimulator', hotelstack: true, competitor: false },
        { name: 'Wettbewerbspreise-Monitor', hotelstack: true, competitor: false },
        { name: 'Nachfrageprognose', hotelstack: true, competitor: 'Basis' },
      ],
    },
    {
      category: 'Gaesteverwaltung',
      features: [
        { name: '360-Grad-Gaesteprofile', hotelstack: true, competitor: 'Basis' },
        { name: 'Treueprogramm-Verwaltung', hotelstack: true, competitor: false },
        { name: 'Gaestekommunikation-Automatisierung', hotelstack: true, competitor: true },
        { name: 'Gaeste-Ausgabenanalysen', hotelstack: true, competitor: false },
        { name: 'Ausweisupload & Verifizierung', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'F&B & Betrieb',
      features: [
        { name: 'POS-Terminal', hotelstack: true, competitor: false },
        { name: 'Zimmerservice-Modul', hotelstack: true, competitor: false },
        { name: 'Kuechenanzeigesystem', hotelstack: true, competitor: false },
        { name: 'Housekeeping-Verwaltung', hotelstack: true, competitor: true },
        { name: 'Wartungsauftraege', hotelstack: true, competitor: false },
        { name: 'Personalplanung', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Enterprise & Multi-Property',
      features: [
        { name: 'Ketten-Dashboard', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Objektuebergreifende Analysen', hotelstack: true, competitor: false },
        { name: 'Zentralisierte Preisverwaltung', hotelstack: true, competitor: false },
        { name: 'Markenstandards-Durchsetzung', hotelstack: true, competitor: false },
        { name: 'Plattform-Superadmin', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resilienz & Offline',
      features: [
        { name: 'Offlinefaehige PWA', hotelstack: true, competitor: false },
        { name: 'Offline-Warteschlange fuer Aenderungen', hotelstack: true, competitor: false },
        { name: 'Hintergrundsynchronisierung bei Wiederverbindung', hotelstack: true, competitor: false },
        { name: 'Konfliktbewusster Abgleich', hotelstack: true, competitor: false },
        { name: 'Installierbare Rezeption', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Firmenkunden & Gruppenverkauf',
      features: [
        { name: 'Firmenratenverwaltung', hotelstack: true, competitor: false },
        { name: 'Gruppenbuchung mit Zimmerlisten', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Offene-Posten- & Produktionsberichte', hotelstack: true, competitor: false },
        { name: 'Restaurantreservierungen', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal & HR',
      features: [
        { name: 'Mitarbeiterverzeichnis & Dienstplanung', hotelstack: true, competitor: false },
        { name: 'Lohnabrechnung', hotelstack: true, competitor: false },
        { name: 'Urlaub & Anwesenheit', hotelstack: true, competitor: false },
        { name: 'Leistungsanalysen', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$79+',
    hotelstackNote: 'Alle 36 Module enthalten. Skaliert von 10-Zimmer-Boutique bis 500+ Zimmer Enterprise. Regionale Preise in EUR, GBP, AED, INR, THB. Kostenloses Onboarding und Migration.',
    competitorNote: 'Gestaffelte Preise ab EUR 79+/Monat. Erweiterte Funktionen hinter hoeheren Stufen gesperrt. Begrenzte Enterprise- und Multi-Property-Funktionen.',
  },
  advantages: [
    'Ueber dreimal so viele Module (36 vs. 10+) ohne Funktionen hinter Premium-Stufen gesperrt',
    'Skaliert von Boutique bis Enterprise — RoomRaccoon ist auf kleine/mittlere Objekte beschraenkt',
    'Vollstaendiges F&B-Modul mit POS, Zimmerservice und Kuechenmanagement enthalten',
    'Vollstaendige Multi-Property-Kettenverwaltung mit zentralisierten Analysen und Tarif-Distribution',
    'Fortschrittliches Ertragsmanagement ueber Basis-KI-Yield hinaus — einschliesslich Prognose und Simulatoren',
    'Treueprogramm-Verwaltung fuer Gaestebindung und Wachstum bei Wiederholungsbuchungen',
    'Globale Reichweite in ueber 40 Laendern vs. RoomRaccoon Europa-Fokus',
    'Personalverwaltung mit Planung, Gehaltsabrechnung und Leistungsverfolgung inklusive',
  ],
  verdict: {
    title: 'Unser Fazit',
    summary: 'RoomRaccoon ist eine solide Wahl fuer kleine europaeische Boutique-Hotels, die ein KI-gestuetztes PMS mit moderner Oberflaeche suchen. Es fehlen jedoch die Tiefe, Skalierbarkeit und betriebliche Breite, die wachsende Objekte benoetigen. HotelStack.io bietet alles, was RoomRaccoon bietet, plus F&B/POS, Enterprise Multi-Property-Verwaltung, erweiterte Ertragstools und globale Compliance — und ist damit die staerkere langfristige Investition.',
    bestFor: [
      'Boutique-Hotels, die Enterprise-Grade-Funktionen ohne Enterprise-Preise wuenschen',
      'Objekte, die F&B, POS und Kuechenmanagement in ihrem HMS benoetigen',
      'Hotels, die von Einzelobjekt zu Multi-Property-Ketten skalieren moechten',
      'Objekte ausserhalb Europas, die globale Compliance und Distribution benoetigen',
      'Hotels, die fortschrittliches Ertragsmanagement ueber Basis-Yield-Optimierung hinaus wuenschen',
    ],
  },
  faqItems: [
    { question: 'Kann ich von RoomRaccoon zu HotelStack.io migrieren?', answer: 'Ja. Unser Migrationsteam uebernimmt den vollstaendigen Datentransfer von RoomRaccoon einschliesslich Gaesteprofilen, Reservierungshistorie, Tarifplaenen und Zimmerkonfigurationen. Die Migration ist kostenlos und wird in der Regel innerhalb von 48 Stunden ohne Ausfallzeiten abgeschlossen.' },
    { question: 'Verfuegt HotelStack.io ueber KI-gestuetzte Funktionen wie RoomRaccoon?', answer: 'Ja. HotelStack.io umfasst intelligentes Yield Management, Nachfrageprognose, dynamische Preisregeln und Ertragssimuloren. Unsere KI-gesteuerten Tools gehen ueber Basis-Yield-Optimierung hinaus und umfassen Wettbewerberueberwachung und Was-Waere-Wenn-Szenarioplanung.' },
    { question: 'Ist HotelStack.io fuer Boutique-Hotels wie RoomRaccoon geeignet?', answer: 'Absolut. Unser Starter-Plan ist fuer Objekte jeder Groesse konzipiert, einschliesslich Boutique-Hotels. Sie erhalten alle 36 Module ab dem ersten Tag ohne Funktionsbeschraenkungen, und die moderne dunkle Luxus-Oberflaeche bietet ein elegantes Erlebnis, das Boutique-Objekte schaetzen.' },
    { question: 'Wie handhabt HotelStack.io Multi-Property-Verwaltung vs. RoomRaccoon?', answer: 'HotelStack.io umfasst ein vollstaendiges Kettenverwaltungs-Dashboard mit objektuebergreifenden Analysen, zentralisierter Tarif-Distribution, Markenstandards und konsolidierter Berichterstattung. RoomRaccoon hat eingeschraenkte Multi-Property-Unterstuetzung, was HotelStack.io zur besseren Wahl fuer wachsende Hotelgruppen macht.' },
  ],
};

export const COMPARISON_DE_P3: Record<string, ComparisonConfig> = {
  'hotelstack-vs-siteminder': SITEMINDER_DE,
  'hotelstack-vs-roomraccoon': ROOMRACCOON_DE,
  ...COMPARISON_DE_P3B,
};
